export default theme => ({
  root: {
    overflow: 'auto'
  },
  paper: {
    padding: theme.spacing(1),
  }
});

